export default __webpack_public_path__ + "static/media/229.77a046ae.gif";